// src/components/store/sections/blog-posts/BlogV79OrigamiribbonSunsetAmber.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV79OrigamiribbonSunsetAmber(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={79}
      archKey="origami_ribbon"
      archLabel="Origami Ribbon Articles"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      btnCls="bg-orange-600 hover:bg-orange-700"
      hexCol="#f59e0b"
      {...props}
    />
  );
}
